// Page-Nav-Store: jede Page meldet ihre Toolbar-Slots an, App.svelte
// rendert daraus die schwebende Pill-Toolbar oben. Pro Mount eine
// Page, daher reicht ein einzelner Slot.
//
// DomainNavBar ist der einzige Caller -- jede Page mounted die als
// Registrar (rendert visuell nichts), die alte Inline-NavBar gibt's
// nicht mehr.

import type { Snippet } from "svelte";

export interface PageNav {
  backTo?: string;
  backLabel?: string;
  info?: Snippet;
  infoTitle?: string;
  // actions: page-spezifische Toolbar-Items, die App.svelte am rechten
  // Rand der Pille rendert. Die Page deklariert das Snippet beim
  // Mount via setPageNav -- damit landen Dropdowns wie "Favoriten"
  // auf der Files-Seite direkt im Command-Center, ohne dass jede
  // Page eine eigene Sub-Toolbar baut.
  actions?: Snippet;
  // wide=true bricht die Default-Breite (max-w-6xl) auf, damit Pages
  // die echt mehr Platz brauchen (Files-Dual-Pane) den Bildschirm
  // sinnvoll nutzen. Pille bleibt mittig auf Default-Breite, der
  // Content darunter wird breiter.
  wide?: boolean;
}

let _nav = $state<PageNav>({});

export function setPageNav(nav: PageNav): void {
  _nav = { ...nav };
}

export function clearPageNav(): void {
  _nav = {};
}

export function getPageNav(): PageNav {
  return _nav;
}
